const number = new Intl.NumberFormat("es-CO", { maximumFractionDigits: 1 });

// Se activa por instancia: las otras gráficas conservan su presentación.
export const valueLabels = {
  id: "visibleValues",
  afterDatasetsDraw(chart, _args, options) {
    const { ctx, chartArea } = chart;
    const placed = [];
    ctx.save();
    ctx.font = `600 ${options.fontSize || 12}px sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";
    ctx.strokeStyle = "#fff";
    ctx.lineWidth = 4;
    ctx.lineJoin = "round";
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      if (!chart.isDatasetVisible(datasetIndex)) return;
      ctx.fillStyle =
        typeof dataset.borderColor === "string" && dataset.borderColor !== "transparent"
          ? dataset.borderColor
          : "#254459";
      chart.getDatasetMeta(datasetIndex).data.forEach((element, index) => {
        const value = dataset.data[index];
        if (!Number.isFinite(value) || element.skip || !chart.getDataVisibility(index)) return;
        const { x, y } = element.getProps(["x", "y"], false);
        if (!Number.isFinite(x) || !Number.isFinite(y) || x < chartArea.left || x > chartArea.right)
          return;
        const text = `${number.format(value)}${options.format === "percent" ? "%" : ""}`;
        const half = ctx.measureText(text).width / 2;
        const labelX = Math.max(chartArea.left + half, Math.min(x, chartArea.right - half));
        let labelY = Math.max(16, y - 8);
        const overlaps = () =>
          placed.some(
            (rect) =>
              Math.abs(rect.x - labelX) < rect.half + half + 4 && Math.abs(rect.y - labelY) < 16
          );
        while (overlaps() && labelY >= 32) labelY -= 16;
        if (overlaps()) {
          labelY = Math.max(16, y - 8);
          while (overlaps()) labelY += 16;
        }
        placed.push({ x: labelX, y: labelY, half });
        ctx.strokeText(text, labelX, labelY);
        ctx.fillText(text, labelX, labelY);
      });
    });
    ctx.restore();
  },
};
